var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNizroIconRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NIZRO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 112,
    fill: "#14223F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.6 112) scale(1.44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    d: "M0,0L49,0L130,133.88L130,0L170,0L170,132.13L117.45,194.13L40,66.12L40,200L0,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58A8F7",
    d: "M170,152.23L170,200L129.52,200Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNizroIconRounded);
export default __webpack_public_path__ + "static/media/nizro-icon-rounded.2b683f3a34662fb6fbb05cbff1751c63.svg";
export { ForwardRef as ReactComponent };